import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'

export function ExportModal({
  exportModalOpen,
  setExportModalOpen,
  exportLimit,
  setExportLimit,
  exporting,
  handleExport
}) {
  return (
    <Dialog open={exportModalOpen} onClose={() => setExportModalOpen(false)} maxWidth='xs' fullWidth>
      <DialogTitle>Exportar usuarios</DialogTitle>
      <DialogContent>
        <div className='flex flex-col gap-3 mt-2'>
          <div className='text-sm text-gray-600 dark:text-gray-300'>
            ¿Cuántos usuarios querés exportar? (máximo 10.000)
          </div>
          <TextField
            type='number'
            size='small'
            fullWidth
            value={exportLimit}
            onChange={e => {
              const val = parseInt(e.target.value, 10)
              if (!isNaN(val)) setExportLimit(val)
            }}
            inputProps={{ min: 1, max: 10000 }}
          />
          <div className='text-xs text-gray dark:text-gray-400'>
            Se exportarán los primeros {Math.min(Math.max(1, exportLimit), 10000)} usuarios según los filtros actuales.
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <button
          className='px-3 py-2 rounded-lg bg-light_gray dark:bg-dk-raised text-black dark:text-gray-100'
          onClick={() => setExportModalOpen(false)}
          disabled={exporting}
        >
          Cancelar
        </button>
        <button
          className='px-3 py-2 rounded-lg bg-primary text-white hover:opacity-90 disabled:opacity-50'
          onClick={handleExport}
          disabled={exporting || exportLimit < 1 || exportLimit > 10000}
        >
          {exporting ? 'Exportando...' : 'Exportar'}
        </button>
      </DialogActions>
    </Dialog>
  )
}
